module.exports = __webpack_public_path__ + "static/media/si-cover.206230c6.jpg";